module.exports = __webpack_public_path__ + "static/media/1-9.6a4b2b8a.mp3";